package com.neurobs.ccab.casr

import com.neurobs.util.{Guid, SecondsTimestamp}

case class SpeechAudioFileView
(
  id: Long,
  filename: String,
  location: Option[String],
  testRunId: Long,
  accountId: Long
)

case class TestTranscriptView
(
  id: Long,
  createdAt: SecondsTimestamp,
  completedAt: Option[SecondsTimestamp],
  testRunId: Long,
  sessionId: Long,
  accountId: Long,
  studyId: Long,
  logfileId: Long,
  logfileOrigFilename: String,
  casrReleaseId: Long,
  transcript: Option[String],
  error: Option[String],
  needsSync: Boolean,
)

case class SyncEndEventData
(
  testTranscriptSyncAttempts: Int,
  testTranscriptSyncSuccesses: Int,
  reviewedTestTranscriptSyncAttempts: Int,
  reviewedTestTranscriptSyncSuccesses: Int,
  errorCount: Int
)















